<template>
    <va-edit-layout>
        <PayWithAmazonEvent-form
            :id="id"
            :title="title"
            :item="item"
        ></PayWithAmazonEvent-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
